import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { AnnualPlanService } from '../providers/annual-plans.services';
import { AnnualPlanData } from '../merger/annual-plan-data-merger';
import { AnnualPlan } from "../../common/models/annual-plan";
import { Observable } from "rxjs";

@Injectable({providedIn: 'root'})
export class AnnualPlanDataResolver implements Resolve<AnnualPlan> {
    constructor(
        private annualPlanService: AnnualPlanService,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return this.annualPlanService.findByPlanId(route.params['organizationCode'], 0, +route.params['annualPlanId']);
    }
}
